"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SnoozeMenu = void 0;

var React = _interopRequireWildcard(require("react"));

var _blocks = require("@bueno/blocks");

var _reactRedux = require("react-redux");

var _snooze = require("../../redux/modules/_BETA/snooze");

var _unsnooze = require("../../redux/modules/_BETA/unsnooze");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _time = require("../../utils/time");

/* eslint-disable no-eq-null */
const InputWrap = _styledComponents.default.div`
  grid-template-columns: 7ch auto;
  align-items: center;
  gap: ${_blocks.spacing.tight};
  padding: 0 ${_blocks.spacing.snug} ${_blocks.spacing.snug} ${_blocks.spacing.snug};
`;
const Input = _styledComponents.default.input`
  border: 1px solid ${_blocks.color.theme.input.default.border};
  padding: ${_blocks.spacing.extraTight};
  height: 32px;
  border-radius: ${_blocks.borderRadius.small};
`;
const Footer = _styledComponents.default.div`
  display: flex;
  justify-content: space-between;
  padding: ${_blocks.spacing.tight};
  background-color: ${_blocks.palette.neutral2};
  border-top: 1px solid ${_blocks.color.theme.divider.solid};
`;

function SnoozeMenuComp(props) {
  const [showCustom, setShowCustom] = React.useState(false);
  const [numSeconds, setNumSeconds] = React.useState(0);
  const inputRef = React.useRef(null);
  React.useLayoutEffect(() => {
    var _inputRef$current;

    if (showCustom) (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
  }, [showCustom]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_blocks.ActionList, null, Object.values(_snooze.SNOOZE_OPTIONS).map(o => /*#__PURE__*/React.createElement(_blocks.ActionItemButton, {
    key: o.value,
    onClick: () => {
      setNumSeconds(o.value);
      setShowCustom(false);
    },
    iconRight: !showCustom && numSeconds === o.value ? /*#__PURE__*/React.createElement(_blocks.CheckSingle, {
      tiny: true
    }) : undefined
  }, o.label)), /*#__PURE__*/React.createElement(_blocks.ActionItemButton, {
    onClick: () => {
      var _inputRef$current2;

      setNumSeconds((0, _time.daysToSeconds)(30));
      setShowCustom(true);
      (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.focus();
    },
    iconRight: showCustom ? /*#__PURE__*/React.createElement(_blocks.CheckSingle, {
      tiny: true
    }) : undefined
  }, "Custom")), /*#__PURE__*/React.createElement(InputWrap, {
    style: {
      display: showCustom ? 'grid' : 'none'
    }
  }, /*#__PURE__*/React.createElement(Input, {
    ref: inputRef,
    type: "number",
    value: (0, _time.secondsToDays)(numSeconds),
    min: 1,
    max: 9999,
    step: 1,
    onKeyPress: event => {
      if (event.key === '.') event.preventDefault();
    },
    onChange: event => {
      const seconds = (0, _time.daysToSeconds)(Number(event.currentTarget.value));
      return setNumSeconds(seconds);
    }
  }), /*#__PURE__*/React.createElement("span", {
    onClick: () => {
      var _inputRef$current3;

      return (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 ? void 0 : _inputRef$current3.focus();
    }
  }, "days")), /*#__PURE__*/React.createElement("hr", {
    style: {
      backgroundColor: _blocks.color.theme.divider.solid,
      height: 1,
      border: 0,
      margin: 0
    }
  }), /*#__PURE__*/React.createElement(Footer, {
    style: {
      flexDirection: props.showUnsnooze ? 'row' : 'row-reverse'
    }
  }, props.showUnsnooze && /*#__PURE__*/React.createElement(_blocks.Button, {
    wafer: true,
    appearance: "outline",
    onClick: props.unsnooze(props.equipRuleIds, props.onClick)
  }, "Unsnooze"), /*#__PURE__*/React.createElement(_blocks.ControlGroup, {
    extraTight: true
  }, /*#__PURE__*/React.createElement(_blocks.Button, {
    wafer: true,
    appearance: "plain",
    onClick: () => {
      var _props$onClick;

      setNumSeconds(0);
      (_props$onClick = props.onClick) === null || _props$onClick === void 0 ? void 0 : _props$onClick.call(props);
    }
  }, "Cancel"), /*#__PURE__*/React.createElement(_blocks.Button, {
    primary: true,
    wafer: true,
    "data-cy": "SnoozeSubmit",
    disabled: numSeconds <= 0,
    onClick: props.snooze(props.equipRuleIds, numSeconds, props.onClick)
  }, "Snooze"))));
}

SnoozeMenuComp.defaultProps = {
  showSnooze: true,
  showUnsnooze: false
};

function mapDispatchToProps(dispatch) {
  return {
    snooze: (equipRuleIds, duration, cb) => () => {
      dispatch((0, _snooze.snoozeEquipRules)({
        equipRuleIds,
        duration
      }));
      if (cb != null) cb();
    },
    unsnooze: (equipRuleIds, cb) => () => {
      dispatch((0, _unsnooze.unsnoozeEquipRules)({
        equipRuleIds
      }));
      if (cb != null) cb();
    }
  };
}

const SnoozeMenu = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(SnoozeMenuComp);
exports.SnoozeMenu = SnoozeMenu;